module.exports = __webpack_public_path__ + "img/au.99524679.png";